import { render, staticRenderFns } from "./QuillToolbar.vue?vue&type=template&id=4b5e069f&"
import script from "./QuillToolbar.vue?vue&type=script&lang=ts&"
export * from "./QuillToolbar.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports